import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";

const AddFeedbackModal = ({
  showAddFeedbackModal,
  modalType,
  setShowAddFeedbackModal,
  selectedRow,
}) => {
  const [feedbackName, setFeedbackName] = useState("");
  const [feedbackScore, setFeedbackScore] = useState("");
  const [isSuggestion, setIsSuggestion] = useState(false);
  const [masterFeedback, setMasterFeedback] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [selectedEmoji, setselectedEmoji] = useState("");
  const [emojiList, setEmojiList] = useState([]);

  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  useEffect(() => {
    if (showAddFeedbackModal) {
      getEmojiList();
      setIsSuggestion(false);
      if (modalType === 1) {
        setFeedbackName(selectedRow?.name);
        setFeedbackScore(selectedRow?.score);
        setselectedEmoji(selectedRow?.image);
        // setMasterFeedback(selectedRow?.masterFeedback)
      }
    }
  }, [showAddFeedbackModal]);

  const closeModal = () => {
    setShowAddFeedbackModal(false);
  };
  const toUnicodeEscape = (str) => {
    return [...str].map(char => `\\u${char.codePointAt(0).toString(16)}`).join('');
  };

  const addNewFeedback = () => {
    if (feedbackName !== "" && (isSuggestion || feedbackScore !== "")) {
      axios({
        method: "POST",
        url: `${baseUrl}/feedback/add`,
        headers: {
          Authorization: token,
        },
        data: {
          name: feedbackName,
          score: feedbackScore,
          branchId: userDetails?.bid,
          customerId: userDetails?.cid,
          image: selectedEmoji,
          suggestion: isSuggestion,
          // masterFeedback: masterFeedback,
          deleted: false,
          // image: imageFile,
        },
      })
        .then((res) => {
          toast.success("Successfully added", {
            position: "bottom-center",
          });

          closeModal();
        })
        .catch((error) => {
          console.log(error);

          if (error.response !== undefined) {
            toast.error(error.response.data.message, {
              position: "bottom-center",
            });
            setButtonLoader(false);
          } else {
            toast.error("Something went wrong", {
              position: "bottom-center",
            });
            setButtonLoader(false);
          }
        });
    } else {
      toast.error("Fields cannot be empty", {
        position: "bottom-center",
      });
    }
  };

  const updateFeedback = () => {
    if (feedbackName !== "" && (isSuggestion || feedbackScore !== "")) {
      axios({
        method: "POST",
        url: `${baseUrl}/feedback/update`,
        headers: {
          Authorization: token,
        },
        data: {
          id: selectedRow?.id,
          name: feedbackName,
          score: feedbackScore,
          branchId: userDetails?.bid,
          customerId: userDetails?.cid,
          image: selectedEmoji,
          // masterFeedback: masterFeedback,
          deleted: false,
        },
      })
        .then((res) => {
          toast.success("Successfully added", {
            position: "bottom-center",
          });

          closeModal();
        })
        .catch((error) => {
          console.log(error);

          if (error.response !== undefined) {
            toast.error(error.response.data.message, {
              position: "bottom-center",
            });
            setButtonLoader(false);
          } else {
            toast.error("Something went wrong", {
              position: "bottom-center",
            });
            setButtonLoader(false);
          }
        });
    } else {
      toast.error("Fields cannot be empty", {
        position: "bottom-center",
      });
    }
  };

  const getEmojiList = () => {
    axios({
      method: "GET",
      url: `${baseUrl}/feedback/imoji`,
      headers: {
        Authorization: token,
      },
    })
      .then((res) => {
        let data = res.data.data;
        setEmojiList(data);
      })
      .catch((error) => {
        console.log(error);

        if (error.response !== undefined) {
          toast.remove();
          toast.error(error.response.data.message, {
            position: "bottom-center",
          });
        } else {
          toast.remove();
          toast.error("Something went wrong", {
            position: "bottom-center",
          });
        }
      });
  };

  return (
    <>
      <div>
        <Toaster />
      </div>
      {showAddFeedbackModal && (
        <div
          className={`modal fade d-block show modal-container`}
          // id="counter-modal"
        >
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {modalType === 0 ? <>Add New Feedback</> : <>Edit Feedback</>}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="row clearfix">
                  <div className="col-12">
                    <div className="input-group input-group-sm mb-3">
                      <p className="input-field-side-text">Suggestion : </p>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={isSuggestion ? true : false}
                          onChange={(e) => {
                            setIsSuggestion(e.target.checked);
                          }}
                        />
                        <span className="slider"></span>
                      </label>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="input-group input-group-sm mb-3">
                      <p className="input-field-side-text">
                        {isSuggestion ? "Suggestion Name : " : "Feedback Name : "}
                      </p>
                      <input
                        autoFocus
                        type="text"
                        className="form-control"
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing-sm"
                        value={feedbackName}
                        onChange={(e) => {
                          setFeedbackName(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  {!isSuggestion && (
                    <div className="col-12">
                      <div className="input-group input-group-sm mb-3">
                        <p className="input-field-side-text">Feedback Emoji : </p>
                        <select
                          className="custom-select modal-select-field select-branch-dropdown"
                          id="inputGroupSelect01"
                          value={selectedEmoji}
                          onChange={(e) => {
                            console.log(e.target.value);
                            setselectedEmoji(e.target.value);
                          }}
                        >
                          <option defaultValue hidden>
                            Select Emoji...
                          </option>
                          {emojiList.map((item, index) => (
                            <option className="emoji-ls-lg" value={item.face} key={index}>
                              {item.face}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                  {!isSuggestion && (
                    <div className="col-12">
                      <div className="input-group input-group-sm mb-3">
                        <p className="input-field-side-text">Feedback Score : </p>
                        <input
                          type="text"
                          className="form-control"
                          aria-label="Small"
                          aria-describedby="inputGroup-sizing-sm"
                          value={feedbackScore}
                          onChange={(e) => {
                            setFeedbackScore(e.target.value.replace(/\D/g, ""));
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {/* <div className="col-12">
                    <div className="input-group input-group-sm mb-3">
                      <p className="input-field-side-text">Image : </p>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/png, image/gif, image/jpeg"
                        // value={imageFile}
                        onChange={(e) => {
                          setImageFile(e.target.files[0]);
                        }}
                      />
                    </div>
                  </div> */}

                  {/* <div className="col-12">
                    <div className="input-group input-group-sm mb-3 modal-input-group">
                      <p className='input-field-side-text display-inline-block float-left'>Master Feedback : </p>
                      <div className="display-inline-block">
                        <label className="switch">
                          <input type="checkbox"
                                 checked={masterFeedback ? true : false}
                                 onChange={(e) => {
                                   setMasterFeedback(e.target.checked);
                                 }} />
                          <span className="slider"></span>
                        </label>
                      </div>
                      <span className='text-info'>
                                                            <i className='fa fa-info-circle mr-1'></i>
                                                            <small style={{ fontSize: "80%" }}>Click on the toggle if the branch will be used to clone later.</small>
                                                        </span>
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  Cancel
                </button>

                {modalType === 0 ? (
                  <Button
                    loading={buttonLoader}
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      addNewFeedback();
                    }}
                  >
                    Save changes
                  </Button>
                ) : (
                  <Button
                    loading={buttonLoader}
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      updateFeedback();
                    }}
                  >
                    Update changes
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddFeedbackModal;
